import { Component, ViewChild, Injector, Output, EventEmitter, ElementRef, ViewEncapsulation, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap';
import { AppComponentBase } from '@shared/common/app-component-base';
import { RegistrationsServiceProxy, EventsServiceProxy, UploadPresenceToRegistrationsDto } from '@shared/service-proxies/service-proxies';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { IAjaxResponse } from 'abp-ng2-module/src/abpHttpInterceptor';
import { AppConsts } from '@shared/AppConsts';
import { TokenService } from 'abp-ng2-module/src/auth/token.service';

@Component({
    selector: 'importPresenceToRegistrationsModal',
    templateUrl: './import-presence-to-registrations-modal.component.html'
})

export class ImportPresenceToRegistrationsModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal') modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    event = undefined;
    events = [];

    active = false;
    saving = false;

    public uploaderFile: FileUploader;
    public temporaryFileUrl: string;
    private temporaryFileName: string;
    private _uploaderFileOptions: FileUploaderOptions = {};

    constructor(
        injector: Injector,
        private _registrationsService: RegistrationsServiceProxy,
        private _eventsService: EventsServiceProxy,
        private _tokenService: TokenService

    ) {
        super(injector);
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $('tabset ul.nav').addClass('m-tabs-line');
        $('tabset ul.nav li a.nav-link').addClass('m-tabs__link');
    }

    close(): void {
        this.active = false;
        this.event = undefined;
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
    }

    public show(): void {
        this.initFileUploader();
        this.active = true;
        this.modal.show();
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
            this.events = result.items;
        });
    }

    // Files
    getTemplate() {
        window.location.assign(AppConsts.remoteServiceBaseUrl +  '/Temp/Modelo_Upload_Presenca_Inscritos.xlsx');
    }

    initFileUploader(): void {

        this.temporaryFileUrl = '';
        this.temporaryFileName = '';

        this.uploaderFile = new FileUploader({ url: AppConsts.remoteServiceBaseUrl + '/Registration/UploadPresenceToRegistrationsFile' });
        this._uploaderFileOptions.autoUpload = true;
        this._uploaderFileOptions.authToken = 'Bearer ' + this._tokenService.getToken();
        this._uploaderFileOptions.removeAfterUpload = true;
        this.uploaderFile.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };
        this.uploaderFile.onSuccessItem = (item, response, status) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success && resp.result.fileName) {
                this.temporaryFileName = resp.result.fileName;
                this.temporaryFileUrl = AppConsts.remoteServiceBaseUrl + '/Temp/Downloads/' + resp.result.fileName + '?v=' + new Date().valueOf();

            } else {
                let message = resp.error ? resp.error.message : resp.result.message;
                this.message.error(message);
            }
        };
        this.uploaderFile.setOptions(this._uploaderFileOptions);
    }

    save(): void {

        let msg = this.l("Will send a notification with the confirmation when the process ends.");

        let input = new UploadPresenceToRegistrationsDto();
        input.eventId = this.event.id;
        input.fileName = this.temporaryFileName;

        this.message.confirm(
            msg,
            (isConfirmed) => {
                if (isConfirmed) {
                this._registrationsService.uploadPresenceToRegistrations(input)
                    .subscribe(() => {
                        this.notify.info(this.l('SavedSuccessfully'));
                        this.close();
                        this.modalSave.emit(null);
                    });
                }
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/event/registrations/modals/import-presence-to-registrations/import-presence-to-registrations-modal.component.ts